import { DOC_FLOW_STATUSES } from '../../../constants/docFlow'
import { INHABITANT_STATUS } from '../../../constants/inhabitant'
import { NEWSBOARD_STATUS } from '../../../constants/newsboard'
import { RENTAL_PORTAL_LISTING_STATUSES } from '../../../constants/rentalPortal'
import { REQUEST_STATUS } from '../../../constants/request'

import { EntityStatusEntities } from './EntityStatus.enums'

export function getEntityStatuses(entity) {
  switch (entity.single) {
    case EntityStatusEntities.Inhabitant:
    case EntityStatusEntities.DocFlowCombining:
    case EntityStatusEntities.DocFlowSending:
      return INHABITANT_STATUS

    case EntityStatusEntities.DocFlow:
      return DOC_FLOW_STATUSES

    case EntityStatusEntities.Newsboard:
      return NEWSBOARD_STATUS
    case EntityStatusEntities.Request:
    case EntityStatusEntities.IdwellToIdwell:
      return REQUEST_STATUS

    case EntityStatusEntities.RentalListing:
      return RENTAL_PORTAL_LISTING_STATUSES
  }
}
